import { Spin } from "antd";
import React, { Suspense, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Main from "../../components/Main/Main";
// import logogamofyy from "../../assets/images/logo.png";
import kidszone from "../../assets/images/toonflix.png";
import ShowLoginInput from "../../components/ShowLoginInput/ShowLoginInput";

const HomePage = () => {
  const search = useLocation().search;
  const [showMenu, setShowMenu] = useState(true);
  const navigate = useNavigate();
  let status = new URLSearchParams(search).get("userExist");
  let servicename = new URLSearchParams(search).get("servicename");
  let ani = new URLSearchParams(search).get("msisdn");

  let last_billed_date = new URLSearchParams(search).get("last_billed_date");
  let price = new URLSearchParams(search).get("price");
  let message = new URLSearchParams(search).get("message");

  let product_id = new URLSearchParams(search).get("product_id");
  let service_id = new URLSearchParams(search).get("service_id");
  let m_act = new URLSearchParams(search).get("m_act");
  let clickid = new URLSearchParams(search).get("clickid");

  console.log("type status ", typeof status);
  console.log("status ", status);

  useEffect(() => {
    if (status === "1")
      return navigate(
        `/kidszone/redirect/?msisdn=${ani}&serviceName=${servicename}?product_id=${product_id}&service_id=${service_id}&price=${price}&id=${clickid}`
      );
  }, [status]);

  useEffect(() => {
    if (ani === "123456789") setShowMenu(true);
    // else setShowMenu(false);
  }, []);

  // if (status === "true")
  //   return navigate(
  //     `/redirect/?ani=${ani}&serviceName=${serviceName}?product_id=${product_id}&service_id=${service_id}&price=${price}&id=${id}`
  //   );

  return (
    <StyledHomePage>
      <Suspense
        fallback={
          <>
            <Spin />
          </>
        }
      >
        {showMenu ? (
          <ShowLoginInput
            serviceType={servicename}
            logo={kidszone}
            price={price}
            product_id={product_id}
            service_id={service_id}
            ani={ani}
            clickid={clickid}
          />
        ) : (
          <Main
            serviceType={servicename}
            logo={kidszone}
            price={price}
            product_id={product_id}
            service_id={service_id}
            ani={ani}
            clickid={clickid}
          />
        )}
      </Suspense>
    </StyledHomePage>
  );
};

export default HomePage;

const StyledHomePage = styled.div`
  position: relative;
  min-height: 100vh;
  min-width: 100vw;
`;
